// Desc: Functions for generating report title based on parameters
const generateReportTitle = ({batch, shedType, date, lastDate, reportName}) => {
   const formattedBatchName = batch?.name ? `${batch.name}-` : "";
   const shedTypeName = shedType?.shed_type && shedType.shed_type !== "None" ? `${shedType.shed_type}-` : "";
   const startDate = date ? (date.getDate()) +"-"+(date.getMonth()+1) + "-" + date.getFullYear() + "-" : "";
   const endDate = lastDate ? "to-" +(lastDate.getDate()) +"-"+(lastDate.getMonth()+1) + "-" + lastDate.getFullYear() + "-" : "";

   const title = `${formattedBatchName}${shedTypeName}${startDate}${endDate}${reportName}_Report`;

   return title
}

const getFarmNameCsvHeader = () => {
   const farmName = typeof window === "undefined" ? "" : window.localStorage.getItem("farmName") || "";
   return `Farm Name,"${String(farmName).replace(/"/g, '""')}"\r\n\r\n`;
}

const formatReportDate = (date) => {
   if (!date) return "";

   const value = new Date(date);
   if (Number.isNaN(value.getTime())) return "";

   return `${String(value.getDate()).padStart(2, "0")}/${String(value.getMonth() + 1).padStart(2, "0")}/${value.getFullYear()}`;
}

const getReportCsvHeader = (reportTitle, reportContext = "") => {
   const escapeCsvValue = value => String(value || "").replace(/"/g, '""');
   let csvHeader = `"${escapeCsvValue(reportTitle)}"\r\n`;
   csvHeader += getFarmNameCsvHeader();
   if (reportContext) {
      csvHeader += `"${escapeCsvValue(reportContext)}"\r\n\r\n`;
   }
   return csvHeader;
}

export { generateReportTitle, formatReportDate, getReportCsvHeader }
